import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getMiljogebyrTilBehandling as getMiljogebyrTilBehandlingAction } from "../../../actions/miljogebyrTilBehandlingActions";
import { getOvertredelseskoderMiljogebyr as getOvertredelseskoderMiljogebyrAction } from "../../../actions/overtredelseskoderMiljogebyrActions";
import { getMiljogebyrTilBehandlingItems } from "../../../selectors/miljogebyrTilBehandlingSelector";
import createPaginationControl from "../../Common/createPaginationControl";
import List from "./List";

const PaginationControl = createPaginationControl(
  "miljogebyrTilBehandling",
  {
    apiCallAction: getMiljogebyrTilBehandlingAction,
    queriesForApiReducerName: "forms.miljogebyrTilBehandlingFilterForm",
  },
  getMiljogebyrTilBehandlingItems,
);

export default function ListContainer(props) {
  const dispatch = useDispatch();

  const miljogebyrTilBehandling = useSelector(
    (state) => state.miljogebyrTilBehandling,
  );
  const miljogebyrTilBehandlingFilterForm = useSelector(
    (state) => state.forms.miljogebyrTilBehandlingFilterForm,
  );
  const miljogebyrTilBehandlingItems = useSelector(
    getMiljogebyrTilBehandlingItems,
  );
  const getMiljogebyrTilBehandling = useCallback(
    () =>
      dispatch(
        getMiljogebyrTilBehandlingAction(
          miljogebyrTilBehandlingFilterForm,
          miljogebyrTilBehandling.page,
          miljogebyrTilBehandling.count,
        ),
      ),
    [dispatch, miljogebyrTilBehandlingFilterForm, miljogebyrTilBehandling],
  );
  const getOvertredelseskoderMiljogebyr = useCallback(
    () => dispatch(getOvertredelseskoderMiljogebyrAction()),
    [dispatch],
  );

  return (
    <List
      {...props}
      miljogebyrTilBehandling={miljogebyrTilBehandlingItems}
      miljogebyrTilBehandlingItems={miljogebyrTilBehandlingItems}
      getMiljogebyrTilBehandling={getMiljogebyrTilBehandling}
      getOvertredelseskoderMiljogebyr={getOvertredelseskoderMiljogebyr}
      PaginationControl={PaginationControl}
    />
  );
}
